export const locale = {
    lang: "es",
    data: {
        CONTRACTORS: {
            CONTRACTORS: "Contratistas",
        },
    },
};
